module.exports = __webpack_public_path__ + "img/97.7eb47cd8.jpg";